import { createContext, useContext, useEffect, useRef, useState } from "react";
import { getToken } from "@/lib/api";

const StreamCtx = createContext({ connected: false, tickers: null, portfolio: null, system: null, lastTs: null, prevPrices: {} });

export function StreamProvider({ children }) {
  const [state, setState] = useState({ connected: false, tickers: null, portfolio: null, system: null, lastTs: null, prevPrices: {} });
  const prev = useRef({});

  useEffect(() => {
    let ws, timer, dead = false, backoff = 1000;
    const connect = () => {
      const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
      ws = new WebSocket(`${base}/api/ws/stream?token=${encodeURIComponent(getToken() || "")}`);
      ws.onopen = () => { backoff = 1000; setState((s) => ({ ...s, connected: true })); };
      ws.onmessage = (ev) => {
        const msg = JSON.parse(ev.data);
        if (msg.type !== "snapshot") return;
        const prevPrices = { ...prev.current };
        msg.tickers.forEach((t) => { prev.current[t.symbol] = t.price; });
        setState({ connected: true, tickers: msg.tickers, portfolio: msg.portfolio, system: msg.system, lastTs: Date.now(), prevPrices });
      };
      ws.onclose = () => {
        setState((s) => ({ ...s, connected: false }));
        if (!dead) { timer = setTimeout(connect, backoff); backoff = Math.min(backoff * 2, 15000); }
      };
      ws.onerror = () => ws.close();
    };
    connect();
    return () => { dead = true; clearTimeout(timer); ws?.close(); };
  }, []);

  return <StreamCtx.Provider value={state}>{children}</StreamCtx.Provider>;
}

export const useStream = () => useContext(StreamCtx);
